// extracted by mini-css-extract-plugin
export var Link = "Link-module--Link--JL_1q";
export var disabled = "Link-module--disabled--2LH8j";